// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
import { useCallback, useEffect, useState } from "react";
import { GeneralContainer, H1, H2, H3, ListItemContainer, TextLink } from "../../components/UI/generalLayout/Layout.styled";
import { Container } from "../company/companyRegister/CompanyRegister.styled";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../..";
import { useLocation, useNavigate } from "react-router-dom";
import { Paths } from '../../enums/Paths';
import { GenericSolidButton } from "../../components/UI/buttons/Button.styled";
import { CircularProgress, Hidden, TextField } from "@mui/material";
import { Div, InputGroup, Label, ButtonGroup, CompanyListItemContainer } from "./UserRoleEditProfile.styled";
import ContainerWithSidebar from "../../components/UI/containerWithSidebar/ContainerWithSidebar";
import Colors from "../../constants/Colors";
import useResponsiveInfo from "../../hooks/useResponsiveInfo";
import GenericModal from "../../components/genericModal/GenericModal";
import EditDependenteModal from "../../components/editDependenteModal/editDependenteModal";
import ItemList from "../../components/itemList/ItemList";
import UserListDependenteItem from "../../components/userListDependenteItem/userListDependenteItem";
import * as personActions from "../../store/actions/person";
import moment from "moment";
import ItemListSmallTable from "../../components/itemListSmallTable/itemListSmallTable";
import * as collaboratorInitial from "../../store/actions/collaboratorInitial";
import Company from "../../models/core/company/Company";
import DependentesListaModel from "../../models/dependente/DependentesListaModel";
import { Auth } from "../../core/http/service/Auth";
import { PersonService } from "../../core/http/service/PersonService";
import Person from "../../models/core/userRole/Person";
import { limparDependente } from "../../store/actions/collaboratorInitial";

// --------------------------------------------------------
// USER ROLE INTERFACE
// --------------------------------------------------------

/**
 * A component that renders a Screen.
 *
 * @param props Properties
 * @param props.route The route
 * @param props.navigation The navigator
 * @returns The component JSX.
 */


interface IEditProfile {    
  personId: string;
  nomeCompleto: string;
  email: string;
  cpf: string;
  dataNascimento: string;
  telefoneResponsavel: string;
  contatoUm: IContato;
  contatoDois: IContato;
}

interface IContato {    
  nome: string;
  email: string;
  telefone: string;
}


 
function UserRole(): JSX.Element {
  // --------------------------------------------------------
  // USER ROLE PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { pessoa } = useSelector((state: any) => state.person);
  const { personId, cpf } = (state as any) ?? {};
  const { isMobile } = useResponsiveInfo();  
  const [profile, setProfile] = useState<IEditProfile>();
  const [showModalSalvar, setShowSalvar] = useState(false);
  const [telefoneErroUm, setTelefoneErroUm] = useState("");
  const [telefoneErroDois, setTelefoneErroDois] = useState("");
  const [showModalSuccess, setShowModalSuccess] = useState(false);
  const [showModalError, setShowModalError] = useState(false);  
  const [titleSucess, setTitleSucess] = useState("");
  const [titleError, setTitleError] = useState("");
  const [emailError, setEmailError] = useState('');

  const currentCompany: Company = useSelector((state: any) => state.login.currentCompany);  
  const dependenteColaborador = useSelector((state: any) => state.collaborationInitial.dependenteColaborador) ?? [];  
  const isLoading = useSelector((state: any) => state.collaborationInitial.isLoading);
  const [isLoadingLocal, setIsLoadingLocal] = useState(true);


  const [unitListHeaderFields] = useState([
    {name: 'Nome', width: '35%', align: 'left'}, 
    {name: 'Cpf', width: '18%', align: 'left'}, 
    {name: 'Parentesco', width: '15%', align: 'left'},
    {name: '', width: '10%', align: 'left'},
    {name: '', width: '8%', align: 'left'},
    {name: 'Ativar/Desativar', width: '20%', align: 'left'}])

  useEffect(() => {
    fetchDependenteData();
  }, [dispatch]);
  
  useEffect(() => {        
      fetchPersonData();  
      fetchDependenteData();      
  }, [personId, currentCompany, currentCompany])

  useEffect(() => {        
    
    if(profile?.contatoUm.nome && !profile?.contatoUm.telefone){
      setTelefoneErroUm("Telefone Obrigatório");
    }else{
      setTelefoneErroUm("");
    }
    if(profile?.contatoDois.nome && !profile?.contatoDois.telefone){
      setTelefoneErroDois("Telefone Obrigatório");
    }else{
      setTelefoneErroDois("");
    }

  }, [profile?.contatoUm, profile?.contatoDois])

  useEffect(() => {
      if (pessoa) {

        const contatos = Array.isArray(pessoa.contatos) ? pessoa.contatos : [];

        const contatosOrdenados = [...contatos].sort((a, b) => {
          const nomeA = a.nome.toLowerCase();
          const nomeB = b.nome.toLowerCase();
          return nomeA.localeCompare(nomeB);
        });
        
        setProfile({
          personId: personId,
          nomeCompleto: pessoa.nome ?? "",
          email: pessoa.email ?? "",
          cpf: pessoa.cpf ?? "",
          dataNascimento: pessoa.dataNascimento ? moment(pessoa.dataNascimento).format("YYYY-MM-DD") : "",
          telefoneResponsavel: pessoa.telefones && pessoa.telefones.length > 0 ? aplicarMascaraTelefone(pessoa.telefones[0]) : '',
          contatoUm: (contatosOrdenados[0] || { nome: "", email: "", telefone: "" }),
          contatoDois: (contatosOrdenados[1] || { nome: "", email: "", telefone: "" })
        });
       
        setTimeout(() => {
          setIsLoadingLocal(false);
        }, 1500);
        
      }
    }, [pessoa]);


  const fetchPersonData = useCallback(async () => {    
    if (personId) {    
        await dispatch(personActions.fetchPerson(personId));
    }
  }, []);

  const onAtualizarDados = async ()=>{
    await dispatch(personActions.fetchPerson(personId));
  }    

  const fetchDependenteData = useCallback(async () => {    
    
    if (currentCompany && cpf) {             
      var body = {
        EmpresaId: currentCompany.id,
        Cpf:  cpf,
      }
      await dispatch(collaboratorInitial.getDependente(body)); 
        
    }
  }, [currentCompany, cpf]);    

  function limparString(str: string) {    
    return str.replace(/[^\d]/g, '');
  }
  
  function aplicarMascaraTelefone(str: string) {
    // Aplicar a máscara (XX) XXXX-XXXX ou (XX) XXXXX-XXXX dependendo do comprimento

    if(str){
      const cleaned = limparString(str);
    
      if (cleaned.length === 10) {
        return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      } else if (cleaned.length === 11) {
        return cleaned.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      } else {
        return cleaned;
      }
    }else{
      return "";
    }
  }
    
  const onConfirmSalvar = async ()=>{
          
    try {            

      if(!profile?.email){
        setShowSalvar(false);
        setShowModalError(true);        
        setTitleError('Para continuar, por favor, forneça um e-mail válido.');
        return;
      }else{
      
        const service: PersonService = new PersonService();      
        
        let telefones = [];
          
        if (pessoa && pessoa.telefones && pessoa.telefones.length > 0) {        
          telefones = [profile?.telefoneResponsavel, ...pessoa.telefones.slice(1)];
        } else {
          telefones = [profile?.telefoneResponsavel];
        }    

        const criarContato = (contato: any) => ({
          grauParentesco: "",
          emergencia: true,
          nome: contato?.nome || "",
          telefone: contato?.telefone || "",
          email: contato?.email || ""
        });

        const contatoUmObj = criarContato(profile?.contatoUm);
        const contatoDoisObj = criarContato(profile?.contatoDois);

        var person = new Person().fromJSON({
          cpf: pessoa.cpf,
          nome: pessoa.nome,
          comoSerChamado: pessoa.comoSerChamado,
          email: profile ? profile?.email : pessoa.email, //muda   
          dataNascimento:
          pessoa.dataNascimento === ""
              ? null
              : moment(pessoa.dataNascimento).format("YYYY-MM-DD"),   
          telefones: telefones, //muda
          contatos: [],
          id: personId, 
        });

        const adicionarContatoSeValido = (contato: any) => {
          if (contato.nome && contato.telefone) {
            person?.contatos?.push(contato);
          }
        };

        adicionarContatoSeValido(contatoUmObj);
        adicionarContatoSeValido(contatoDoisObj);

        // Validar se existe pelo menos um contato preenchido
        if (!person?.contatos || person.contatos.length === 0) {
          setShowSalvar(false);
          setShowModalError(true);        
          setTitleError('Para continuar, por favor, forneça ao menos um contato válido.');
          return;
        
        }else{
          
          var retorno = await service.editPessoaInformation(person);

          if(retorno.status == 200){        
            setShowSalvar(false);
            setTitleSucess('Operação realizada com sucesso! As alterações no colaborador foram efetuadas com êxito.');
            setShowModalSuccess(true);        
          }else{
            setTitleError('Desculpe, ocorreu um erro ao tentar alterar as informações do colaborador.');        
            setShowModalError(true);
          }         
        }
          
      }
      
    } catch (error) {
        console.log(error)
        handleError(error);
        setShowSalvar(false);
        setShowModalError(true);
    }

  }

  const handleError = (error: any) => {
    if (
      error &&
      error.response &&
      error.response.data &&
      error.response.data.errors &&
      error.response.data.errors.length > 0
    ) {
      setTitleError(`Erro: ${error.response.data.errors[0]}`);
    } else {
      setTitleError('Erro desconhecido.');
    }
  };

  const handleBackClick = useCallback(async () => {    
    await dispatch(collaboratorInitial.limparDependente()); 
          
    navigate(Paths.UserRole); 
  }, []);  

  const textFieldStyle = {
    fontSize: isMobile ? 14 : 16,
  };

  const maskCPF = (value: string) => {
    return value
      .replace(/\D/g, '')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2') 
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  };

  function formatarTelefone(telefone: string) {
    telefone = telefone.replace(/\D/g, '');
  
    // Limita o número de caracteres a 14 (incluindo parênteses, traço e espaço)
    if (telefone.length > 11) {
      telefone = telefone.substring(0, 11);
    }
  
    if (telefone.length === 11) {
      telefone = telefone.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
    } else if (telefone.length === 10) {
      telefone = telefone.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
    } else if (telefone.length === 9) {
      telefone = telefone.replace(/^(\d{5})(\d{4})$/, '$1-$2');
    } else if (telefone.length === 8) {
      telefone = telefone.replace(/^(\d{4})(\d{4})$/, '$1-$2');
    }
  
    return telefone;
  }

  const handleChangeTelefone = (campo: string, e: any) => {
      const telefoneFormatado = formatarTelefone(e.target.value);
      setProfile((prevProfile: any) => ({
          ...prevProfile,
          [campo]: {
          ...prevProfile[campo],
          telefone: telefoneFormatado,
          },
      }));
  };   
  
  const handleChangeTelefoneResponsavel = (e: any) => {
    const telefoneFormatado = formatarTelefone(e.target.value);
    setProfile((prevProfile: any) => ({
        ...prevProfile,
        telefoneResponsavel: telefoneFormatado,
    }));
  };
  
  const handleEmailChange = (e: any) => {
    const newEmail = e.target.value;

    setProfile((prevProfile: any) => ({
      ...prevProfile,
      email: newEmail,
    }));

    // Resetar a mensagem de erro quando o usuário começa a digitar
    if (emailError) {
      setEmailError('');
    }
  };

  const validateEmail = () => {
    if (!profile?.email) {
      setEmailError('O e-mail é obrigatório.');
    } else {
      setEmailError('');
    }
  };

  return (
    <ContainerWithSidebar>
      <GeneralContainer style={{ marginBottom: "2%", marginTop: -20 }}>

        <Container>
          <TextLink
            style={{ fontSize: 14, color: Colors.SPM600, marginTop: 20 }}
            onClick={handleBackClick}
          >
            {"< Voltar para a tela de Perfil"}
          </TextLink>
        </Container>   
        <Container>      
          <H1>Editar Perfil</H1>
        </Container>   

        {isLoadingLocal || isLoading? (<div style={{ textAlign: 'center', marginTop: 50 }}>
                <CircularProgress />
            </div>) : (
              <>

              <Container>      
                <H2>Colaborador</H2>          
              </Container>   
              <Container></Container>                
              <>
                <Div>
                  <InputGroup>            
                    <Label htmlFor="nomeCompleto">Nome</Label>
                    <TextField
                      id="nomeCompleto"
                      variant="standard"                
                      value={profile?.nomeCompleto || ''}
                      onChange={(e: any) => {
                        setProfile((prevProfile: any) => ({
                          ...prevProfile,
                          nomeCompleto: e.target.value,
                        }));
                      }}
                      type="text"
                      disabled={true}
                    /> 
                  </InputGroup>
                  <InputGroup>
                    <Label htmlFor="cpf">CPF</Label>
                    <TextField
                      id="cpf"
                      variant="standard"
                      value={profile?.cpf ? maskCPF(profile.cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')) : ''}
                      onChange={(e) => {
                        setProfile((prevProfile: any) => ({
                          ...prevProfile,
                          cpf: e.target.value,
                        }));
                      }}
                      type="text"
                      disabled={true}
                    />
                  </InputGroup>
                </Div>

                <Container>
                  <InputGroup>
                    <Label htmlFor="dataNascimento">Data de Nascimento</Label>
                    <TextField
                      id="dataNascimento"
                      variant="standard"
                      value={profile ? moment(profile?.dataNascimento, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''}
                      onChange={(e) => {
                        setProfile((prevProfile: any) => ({
                          ...prevProfile,
                          dataNascimento: e.target.value,
                        }));
                      }}
                      type="text"
                      disabled={true}
                    />
                  </InputGroup>

                  <InputGroup>
                    <Label htmlFor="email" className="required-label">E-mail</Label>
                    <TextField
                      id="email"
                      variant="standard"
                      value={profile?.email}
                      onChange={handleEmailChange}
                      onBlur={validateEmail}
                      type="text"
                      error={!!emailError}
                    />
                  {emailError && <p style={{ color: 'red' }}>{emailError}</p>}
                </InputGroup>
            

                </Container>

                <Container>
                  <InputGroup>
                    <Label htmlFor="telefone" style={textFieldStyle}>Telefone para contato</Label>
                    <TextField
                      id="telefone"
                      variant="standard"
                      value={profile?.telefoneResponsavel || ''}
                      onChange={(e) => handleChangeTelefoneResponsavel(e)}
                      type="text"

                    />
                  </InputGroup>
                
                </Container>          
                <div>
                  {/* CONTATO 1 */}
                  <div><H3> Contato 1</H3></div>
                  <Container style={{ display: 'flex', flexWrap: 'wrap' }}>
                    <InputGroup style={{ flex: '1 1 30%', margin: '0 10px' }}>
                      <Label htmlFor="nome1">Nome</Label>
                      <TextField
                        id="nome1"
                        variant="standard"
                        value={profile?.contatoUm.nome || ''}
                        onChange={(e) => {
                          setProfile((prevProfile: any) => ({
                            ...prevProfile,
                            contatoUm: {
                              ...prevProfile.contatoUm,
                              nome: e.target.value,
                            },
                          }));
                        }}
                        type="text"
                        disabled={false}
                      />
                    </InputGroup>
                    <InputGroup style={{ flex: '1 1 30%', margin: '0 10px' }}>
                      <Label htmlFor="email1">E-mail</Label>
                      <TextField
                        id="email1"
                        variant="standard"
                        value={profile?.contatoUm.email || ''}
                        onChange={(e) => {
                          setProfile((prevProfile: any) => ({
                            ...prevProfile,
                            contatoUm: {
                              ...prevProfile.contatoUm,
                              email: e.target.value,
                            },
                          }));
                        }}
                        type="text"
                      />
                    </InputGroup>
                    <InputGroup style={{ flex: '1 1 30%', margin: '0 10px' }}>
                      <Label htmlFor="telefone1">Telefone</Label>
                      <TextField
                        error={telefoneErroUm ? true : false}
                        id="telefone1"
                        variant="standard"
                        value={profile?.contatoUm.telefone || ''}
                        onChange={(e) => handleChangeTelefone('contatoUm', e)}
                        type="text"
                      />
                      {telefoneErroUm && (
                        <span style={{ color: 'red', marginLeft: '5px' }}>{telefoneErroUm}</span>
                      )}
                    </InputGroup>              
                  </Container>
                  {/* CONTATO 1 */}

                  {/* CONTATO 2 */}
                  <div><H3> Contato 2</H3></div>
                  <Container style={{ display: 'flex', flexWrap: 'wrap' }}>
                    <InputGroup style={{ flex: '1 1 30%', margin: '0 10px' }}>
                      <Label htmlFor="nome2">Nome</Label>
                      <TextField
                        id="nome2"
                        variant="standard"
                        value={profile?.contatoDois.nome || ''}
                        onChange={(e) => {
                          setProfile((prevProfile: any) => ({
                            ...prevProfile,
                            contatoDois: {
                              ...prevProfile.contatoDois,
                              nome: e.target.value,
                            },
                          }));
                        }}
                        type="text"
                        disabled={false}
                      />
                    </InputGroup>
                    <InputGroup style={{ flex: '1 1 30%', margin: '0 10px' }}>
                      <Label htmlFor="email2">E-mail</Label>
                      <TextField
                        id="email2"
                        variant="standard"
                        value={profile?.contatoDois.email || ''}
                        onChange={(e) => {
                          setProfile((prevProfile: any) => ({
                            ...prevProfile,
                            contatoDois: {
                              ...prevProfile.contatoDois,
                              email: e.target.value,
                            },
                          }));
                        }}
                        type="text"
                      />
                    </InputGroup>
                    <InputGroup style={{ flex: '1 1 30%', margin: '0 10px' }}>
                      <Label htmlFor="telefone2">Telefone</Label>
                      <TextField
                        error={telefoneErroDois ? true : false}
                        id="telefone2"
                        variant="standard"
                        value={profile?.contatoDois.telefone || ''}
                        onChange={(e) => handleChangeTelefone('contatoDois', e)}
                        type="text"
                      />
                      {telefoneErroDois && (
                        <span style={{ color: 'red', marginLeft: '5px' }}>{telefoneErroDois}</span>
                      )}                
                    </InputGroup>
                  </Container>
                  {/* CONTATO 2 */}
                </div>

                <Div>
                  <ButtonGroup>
                    <GenericSolidButton color={Colors.SPM600} style={{ width: 150 }} onClick={() => setShowSalvar(true)}>
                      Salvar
                    </GenericSolidButton>
                  </ButtonGroup>
                </Div>
                <br/>               
              </>
      
              <Container>      
                <H2>Dependentes</H2>
              </Container> 
              <Container>
              </Container>  

              <ItemListSmallTable list={[dependenteColaborador]} listHeader={unitListHeaderFields}>
                  <ListItemContainer>
                      {                  
                        !isLoading ?
                          dependenteColaborador && dependenteColaborador.length > 0 ?
                            dependenteColaborador.map((item: DependentesListaModel) => {
                                return (
                                <>
                                    <UserListDependenteItem
                                        item={item}
                                        cpfResponsavel={profile?.cpf}  />
                                </>
                                )
                            })
                            :
                              <div style={{textAlign: 'center', padding: 20}}>Não há dependentes cadastrados para este colaborador.</div>
                        :
                          <div style={{textAlign: 'center', padding: 20}}>
                            <CircularProgress />
                          </div>
                      }
                  </ListItemContainer>
              </ItemListSmallTable> 
         
            </>
          )}
        </GeneralContainer>
      <GenericModal                 
        visible={showModalSalvar} 
        onCancel={onConfirmSalvar} 
        onConfirm={ () => setShowSalvar(false)} 
        modalTitle={'Tem certeza de que deseja salvar as alterações no seu perfil? Verifique se todas as informações estão corretas antes de prosseguir.'} 
        modalSubtitle={''} 
        cancelButtonMsg={'Voltar'} 
        confirmButtonMsg={'Confirmar'}                
      />

      <GenericModal                 
          visible={showModalSuccess} 
          onCancel={() => setShowModalSuccess(false)} 
          onConfirm={() => onAtualizarDados} 
          modalTitle={titleSucess} 
          modalSubtitle={''} 
          cancelButtonMsg={''} 
          confirmButtonMsg={'Ok'}                
      />    

      <GenericModal                 
          visible={showModalError} 
          onCancel={() => setShowModalError(false)} 
          onConfirm={() => setShowModalError(false)} 
          modalTitle={titleError} 
          modalSubtitle={''} 
          cancelButtonMsg={''} 
          confirmButtonMsg={'Ok'}                
      />       

    </ContainerWithSidebar>
  );
}

export default UserRole;
